import styled from 'styled-components';

import { Divider } from '@xing-com/divider';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { List, ListItem } from '@xing-com/list';
import {
  scale000,
  scale010,
  scale100,
  scale150,
  scale210,
  space4XL,
  space5XL,
  spaceS,
  spaceXS,
  spaceXXL,
} from '@xing-com/tokens';
import { Hero, Headline } from '@xing-com/typography';

const StyledHeadline = styled(Headline)`
  margin-top: ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space4XL};
  }
`;

const StyledDivider = styled(Divider)`
  width: 100%;
`;

const StyledList = styled(List)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: calc(${scale150} + ${scale010});

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${scale100};
  }
`;

const StyledListItem = styled(ListItem)`
  padding: ${scale000};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const Articles = styled.div`
  margin: ${spaceXXL} ${scale000} calc(${spaceXXL} + ${spaceXS});
`;

const StyledHero = styled(Hero)`
  scroll-margin: ${scale210};
  margin-bottom: ${spaceS};
`;

export const Styled = {
  Headline: StyledHeadline,
  Divider: StyledDivider,
  List: StyledList,
  ListItem: StyledListItem,
  Articles,
  Hero: StyledHero,
};
